export default __webpack_public_path__ + "static/hw_ff_ultra-led-10f0270aac0b100664839926eaf6082d.png";